export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path.endsWith('/')) return

  return navigateTo({
    path: `${to.path}/`,
    query: to.query,
    hash: to.hash,
  })
})
